import type { ComposerProfile } from '../stores/types'

export const createPreviewProfile = (
  service: string = 'fake',
  userAvatar?: string,
): ComposerProfile => {
  return {
    id: service,
    serviceType: service,
    serviceName: service,
    serviceUsername: 'buffer',
    serviceFormattedUsername: 'Buffer',
    service: {
      name: service,
      username: 'buffer',
      formattedUsername: 'Buffer',
    },
    images: {
      avatar: userAvatar ?? '',
    },
    timezone: 'Europe/London',
    shouldBeAutoSelected: false,
    isDisabled: false,
    serviceId: '1234567890',
    instagramDirectEnabled: true,
    subprofiles: [],
    locationData: '',
    canAssociateLocation: true,
    profileHasPostingSchedule: true,
    displayName: 'Buffer',
    serverUrl: null,
    isSelected: false,
    selectedSubprofileId: null,
    subprofilesOrignatedFromAPI: null,
    defaultToReminders: false,
    shorteningDomain: 'buff.ly',
    appState: {
      isSubprofileCreationPending: false,
    },
    isFake: true,
    utmTrackingEnabled: false,
  }
}
